import { useState, useEffect } from "react";
import { Method_POST_CONTEXTO } from "../../../../../../service/api";
import { formatTelefone } from "../../../../../../function/utilis/function";
import { Form} from "antd";
import { toast } from "react-toastify";

import ModalEditarContato from "./ModalEditarContato";
import ModalAdicionarContato from "./ModalCriarNovoContato";
import TabelaContatos from "./TabelaContatoCliente";

export function Contexto({ selectedIdCliente }) {

    const [dadosCliente, setDadosCliente] = useState([]);
    const [contatoCliente, setContatoCliente] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [isModalAddNovoContato, setIsModalAddNovoContato] = useState(false);
    const [isModalEdit, setIsModalEdit] = useState(false);
    const [contatoSelecionado, setContatoSelecionado] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        if (selectedIdCliente) {
            fetchContextoCompleto(selectedIdCliente);
        }
    }, [selectedIdCliente]);

    const fetchContextoCompleto = async (idCliente) => {
        setIsLoading(true);
        try {
            const urlContexto = `contador/cliente/contexto`;
            const dataContexto = { id: idCliente };
            const responseContexto = await Method_POST_CONTEXTO(urlContexto, dataContexto);

            if (responseContexto) {
                setDadosCliente(responseContexto)
                console.log("Contexto:", responseContexto);
            }

            // segunda chamada
            const urlContato = `/cliente/contato/listar`;
            const dataContato = { id: idCliente }; // pode passar id aqui tbm se a API precisar
            const responseContato = await Method_POST_CONTEXTO(urlContato, dataContato);

            if (responseContato) {
                setContatoCliente(responseContato || [])
                console.log("Contato:", responseContato);
            }

        } catch (error) {
            console.error("Erro ao buscar contexto/contato:", error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const cadastrarNovoContato = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();

            const urlContexto = `cliente/contato/cadastrar`;
            const telefoneLimpo = values.telefone.replace(/\D/g, "");
            const dataContexto = {
                nome: values.nome,
                email: values.email,
                telefone: telefoneLimpo,
            };

            await Method_POST_CONTEXTO(urlContexto, dataContexto);

            await fetchContextoCompleto(selectedIdCliente);
            toast.success("Contato salvo com sucesso!");

            // fechar modal e resetar form
            setIsModalAddNovoContato(false);
            form.resetFields();

        } catch (error) {
            if (error.errorFields) {
                // erro de validação do Ant Design
                console.error("Erro de validação:", error.errorFields);
                // Se quiser exibir o primeiro erro no toast:
                const firstError = error.errorFields[0]?.errors[0];
                if (firstError) toast.error(firstError);
            } else {
                // erro de requisição ou outro problema
                console.error("Erro ao cadastrar contato:", error.message || error);
                toast.error("Erro ao cadastrar contato!");
            }
        } finally {
            setIsLoading(false);
        }

    };

    const abrirModalEditar = (contato) => {
        setContatoSelecionado(contato);
        form.setFieldsValue({
            nome: contato.nome,
            email: contato.email,
            telefone: contato.telefone,
        });
        setIsModalEdit(true);
    };

    const atualizarContato = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();

            const url = `cliente/contato/atualizar`;
            const telefoneLimpo = values.telefone.replace(/\D/g, "");
            const data = {
                id: contatoSelecionado.id,
                nome: values.nome,
                email: values.email,
                telefone: telefoneLimpo,
            };

            await Method_POST_CONTEXTO(url, data);

            toast.success("Contato atualizado com sucesso!");
            await fetchContextoCompleto(selectedIdCliente);

            setIsModalEdit(false);
            form.resetFields();
        } catch (error) {
            if (error.errorFields) {
                const firstError = error.errorFields[0]?.errors[0];
                if (firstError) toast.error(firstError);
            } else {
                console.error("Erro ao atualizar contato:", error.message || error);
                toast.error("Erro ao atualizar contato!");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const removerContato = async (id) => {
        setIsLoading(true);
        try {
            const urlContexto = `cliente/contato/remover`;
            const dataContexto = { id: String(id) };
            const responseContexto = await Method_POST_CONTEXTO(urlContexto, dataContexto);

            await fetchContextoCompleto(selectedIdCliente);
            toast.success("Contato removido com sucesso!")


        } catch (error) {
            console.error("Erro ao buscar contexto/contato:", error.message);
        } finally {
            setIsLoading(false);
        }
    }

    const cancel = e => {
        console.log(e);
    };

    return (
        <>
            <TabelaContatos
                contatoCliente={contatoCliente}
                isLoading={isLoading}
                abrirModalEditar={abrirModalEditar}
                removerContato={removerContato}
                setIsModalAddNovoContato={setIsModalAddNovoContato}
                cancel={cancel}
                formatTelefone={formatTelefone}
            />


            {/* Modal de adicionar */}
            <ModalAdicionarContato
                isModalAddNovoContato={isModalAddNovoContato}
                setIsModalAddNovoContato={setIsModalAddNovoContato}
                form={form}
                isLoading={isLoading}
                onCadastrarContato={cadastrarNovoContato}
            />

            {/* Modal de edição */}
            <ModalEditarContato
                isModalEdit={isModalEdit}
                setIsModalEdit={setIsModalEdit}
                form={form}
                isLoading={isLoading}
                contatoSelecionado={contatoSelecionado}
                onAtualizarContato={atualizarContato}
            />
        </>
    );

}

export default Contexto;